<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceRecord\viewAttendanceRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-01 13:29:28
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceInternal_form_viewTitle')"
    :editBtn="
      iSEdited == false &&
      hasBtn('edit-admin-attendance-record') &&
      Data &&
      !Number(Data['is_locked'])
    "
    @edit="iSEdited = true"
    backgroundClass="transparent"
    :initData="{
      attendance_modification_reason_uuid: attendance_modification_reason_uuid,
      remarks: remarks,
    }"
    @change="(changed) => (isChanged = changed)"
    :checkData="['attendance_modification_reason_uuid', 'remarks']"
    widthClass="max-1000"
    pad="0"
  >
    <template v-slot:appendTitle>
      <span
        class="text--secondary text-body-2 px-2"
        v-if="Data && Data.utc_att_date"
        >{{ $getDateTime(Data.utc_att_date, "YYYY/MM/DD") }}</span
      >
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!Data" />
      <v-card class="pa-0 mb-2 elevation-0" tile v-if="Data">
        <v-card-text
          class="pa-0 mrc_map scroll_content_no fill-height"
          :style="{
            background: 'url(' + mapbg + ')',
            minHeight: $vuetify.breakpoint.height - 56 - 78 - 72 - 72 + 'px',
          }"
        >
          <!-- 2020-09-19 改为不显示地图 v-show="false"-->
          <v-sheet
            class="panel_btn text-center transparent"
            @click="showMap = true"
            v-if="!showMap"
          >
            <svg-icon size="72" fill="grey" iconClass="NoMap" />
            <div class="primary--text">View Map</div>
          </v-sheet>
          <v-container
            class="
              transparent
              panel_left
              d-flex
              justify-start
              flex-row
              fill-height
              pa-0
              ma-0
            "
            :style="{ width: leftWidth + 30 + 'px' }"
          >
            <v-sheet
              height="100%"
              :width="leftWidth"
              color="rgba(0,0,0,0.38)"
              style="overflow-x: hidden"
              :class="leftWidth == 0 ? 'pa-0' : 'pa-4'"
              class="ma-0 scroll_content_y"
            >
              <!-- person -->
              <v-sheet class="rounded-xl px-2" elevation="1">
                <v-list-item dense two-line class="pa-0 ma-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      size="36"
                      :isTemp="Data.is_temp"
                      :src="Data.staff_avatar"
                      :staff_name="Data.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">
                      {{ $getCommonLangValue(Data.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ Data.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-body-2">
                      {{ $getCommonLangValue(Data.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-sheet>
              <!-- tag -->
              <v-sheet
                class="
                  transparent
                  d-flex
                  flex-row
                  justify-space-between
                  mt-4
                  align-center
                "
              >
                <div v-if="Data">
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_late_1')"
                    v-if="Number(Data['is_late'])"
                    >{{ $t("label_essweb_system_tag_label_lateLabel") }}</v-chip
                  >
                  <v-chip
                    small
                    :color="$getTagColors($card_line_colors, 'is_ot_1')"
                    class="ma-1 white--text"
                    v-if="Number(Data['is_ot'])"
                    >{{ $t("label_essweb_system_tag_label_otLabel") }}</v-chip
                  >
                  <v-chip
                    small
                    v-if="Number(Data['is_missing_punch'])"
                    :color="
                      $getTagColors($card_line_colors, 'is_missing_punch_1')
                    "
                    class="ma-1 white--text"
                    >{{
                      $t("label_essweb_system_tag_label_isMissingPunchLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    v-if="Number(Data['is_adhoc'])"
                    :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
                    class="ma-1 text--primary"
                    >{{
                      $t("label_essweb_system_tag_label_isAdhocLabel")
                    }}</v-chip
                  >
                  <!-- <v-chip
                    small
                    color="#12B282"
                    class="white--text"
                    v-if="Number(Data['is_on_leave'])"
                    >{{
                      $t("label_essweb_system_tag_label_leaveLabel")
                    }}</v-chip> -->
                  <template v-if="Number(Data['is_on_leave'])">
                    <v-chip
                      small
                      outlined
                      :color="leave.color_code"
                      v-for="(leave, index) in Data.leave_info"
                      :key="`leave--${index}`"
                      class="ma-1"
                      >{{
                        $getCommonLangValue(leave["leave_type_name"])
                      }}</v-chip
                    >
                  </template>
                  <template v-if="Number(Data['holiday_info'])">
                    <v-chip
                      small
                      :color="$getTagColors($card_line_colors, 'is_holiday_1')"
                      v-for="(holiday, index) in Data['holiday_info']"
                      :key="`holiday--${index}`"
                      class="ma-1 text--primary"
                      >{{
                        $getCommonLangValue(holiday["holiday_name"])
                      }}</v-chip
                    >
                  </template>
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
                    v-if="Number(Data['is_onDuty'])"
                    >{{
                      $t("label_essweb_system_tag_label_isOnDutyLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="
                      $getTagColors($card_line_colors, 'is_early_leave_1')
                    "
                    v-if="Number(Data['is_early_leave'])"
                    >{{
                      $t("label_essweb_system_tag_label_earlyLeaveLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_absense_1')"
                    v-if="Number(Data['is_absense'])"
                    >{{
                      $t("label_essweb_system_tag_label_absenseLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 text--primary"
                    :color="
                      $getTagColors($card_line_colors, 'is_work_from_home_1')
                    "
                    v-if="Number(Data['is_work_from_home'])"
                    >{{
                      $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 text--primary"
                    :color="
                      $getTagColors($card_line_colors, 'is_out_of_office_1')
                    "
                    v-if="Number(Data['is_out_of_office'])"
                    >{{
                      $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
                    }}</v-chip
                  >
                </div>
                <v-btn
                  icon
                  :color="$getTagColors($card_line_colors, 'is_locked_1')"
                  v-if="Number(Data['is_locked'])"
                >
                  <span class="material-icons-round">lock</span>
                </v-btn>
              </v-sheet>
              <!-- shift -->
              <v-sheet
                class="rounded-xl pa-3 mt-4"
                style="overflow: hidden"
                elevation="1"
              >
                <v-sheet class="d-flex flex-row justify-space-between">
                  <div style="width: 24px" class="text-center">
                    <svg-icon
                      size="24"
                      :fill="Data['official_shift_color_code']"
                      iconClass="LabeledColour"
                    />
                  </div>
                  <div
                    style="max-width: 40%"
                    class="pl-1 d-inline-block text-truncate"
                  >
                    {{ $getCommonLangValue(Data["official_shift_name"]) }}
                  </div>
                  <v-spacer></v-spacer>
                  <div class="text--secondary">
                    {{
                      $getDateTime(Data["official_start_utc_time"], "HH:mm") +
                      " - " +
                      $getDateTime(Data["official_end_utc_time"], "HH:mm")
                    }}
                  </div>
                </v-sheet>
                <!-- site bug687 -->
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['site_name']"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon size="16" fill="grey" iconClass="site" />
                  </div>
                  <div class="pl-1 text--secondary">
                    {{ $getCommonLangValue(Data["site_name"]) }}
                  </div>
                </v-sheet>
                <!-- cost_center_name bug688 -->
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['cost_center_name']"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon size="16" fill="grey" iconClass="cost_center" />
                  </div>
                  <div class="pl-1 text--secondary">
                    {{ $getCommonLangValue(Data["cost_center_name"]) }}
                  </div>
                </v-sheet>
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['leave_type_remark_name']"
                >
                  <div
                    style="width: 24px"
                    class="text-center d-flex align-center justify-center"
                  >
                    <span class="material-icons-round text--secondary md-16"
                      >event</span
                    >
                  </div>
                  <div class="pl-1 text--secondary">
                    {{ $getCommonLangValue(Data["leave_type_remark_name"]) }}
                  </div>
                </v-sheet>
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['remarks']"
                >
                  <div style="width: 24px" class="text-center flex-shrink-1">
                    <svg-icon
                      size="16"
                      fill="rgba(0, 0, 0, 0.54)"
                      iconClass="mini_doc"
                    />
                  </div>
                  <div
                    class="pl-1 text--secondary text-ellipsis-2"
                    style="width: calc(100% - 24px)"
                    :title="Data['remarks']"
                  >
                    {{ Data["remarks"] }}
                  </div>
                </v-sheet>
              </v-sheet>
              <!-- event -->
              <v-sheet
                elevation="1"
                class="rounded-xl d-flex mt-4 flex-column flex-grow-1"
              >
                <v-sheet
                  class="ma-4"
                  v-for="(item, index) in Data['ess_att_attendance_detail']"
                  :key="`detail${index}`"
                >
                  <v-sheet class="text-subtitle-1" style="width: 100%">{{
                    $getCommonLangValue(item.event_type_name)
                  }}</v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary lighten-4 rounded-xl mr-2"
                    ></v-sheet>
                    <v-sheet>
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_scheduleShiftTimeLabel"
                          )
                        }}
                      </div>
                      <div class="text-subtitle-2">
                        {{
                          $getDateTime(item.schedule_start_utc_time, "HH:mm") +
                          " - " +
                          $getDateTime(item.schedule_end_utc_time, "HH:mm")
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary lighten-2 rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet>
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_officialShiftTimeLabel"
                          )
                        }}
                      </div>
                      <div class="text-subtitle-2">
                        {{
                          $getDateTime(item.official_start_utc_time, "HH:mm") +
                          " - " +
                          $getDateTime(item.official_end_utc_time, "HH:mm")
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary base rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet width="100%">
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_actualPunchTime"
                          )
                        }}
                      </div>
                      <!-- <div class="text-subtitle-2">
                        {{
                          $getDateTime(
                            item.actual_punch_in_utc_datetime,
                            "HH:mm"
                          ) +
                            " - " +
                            $getDateTime(
                              item.actual_punch_out_utc_datetime,
                              "HH:mm"
                            )
                        }}
                      </div> -->
                      <div
                        class="
                          d-flex
                          flex-row
                          justify-space-between
                          flex-grow-1
                          mt-2
                        "
                        style="width: 100%"
                      >
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.actual_punch_in_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                        <div style="width: 20px" class="text-center">-</div>
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.actual_punch_out_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <!--  -->
                  <v-sheet
                    class="d-flex flex-row justify-start mt-2"
                    v-if="iSEdited"
                  >
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary rounded-xl mr-2"
                    ></v-sheet>
                    <v-sheet width="100%">
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_modifilyOfficialPunchTime"
                          )
                        }}
                      </div>
                      <div
                        class="
                          d-flex
                          flex-row
                          justify-space-between
                          flex-grow-1
                          mt-2
                        "
                        style="width: 100%"
                      >
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          <span v-if="!Number(item.is_punch_in_required)">
                            {{
                              $getDateTime(
                                item.modified_punch_in_utc_datetime_save,
                                "HH:mm"
                              )
                            }}
                          </span>
                          <TimePickerSheet
                            v-if="iSEdited && Number(item.is_punch_in_required)"
                            isRequire
                            :show48="23"
                            showDay
                            hideDetail
                            @modify="
                              item.is_change_modified_punch_in_utc_datetime = true
                            "
                            :showLabel="false"
                            :max="item.modified_punch_out_utc_datetime"
                            :value="item.modified_punch_in_utc_datetime"
                            :defaultTime="item.modified_punch_in_utc_datetime"
                            placeholder="--:--"
                            @change="
                              (time) => {
                                item.modified_punch_in_utc_datetime = time;
                              }
                            "
                          />
                        </v-sheet>
                        <div style="width: 20px" class="text-center">-</div>
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          <span v-if="!Number(item.is_punch_out_required)">
                            {{
                              $getDateTime(
                                item.modified_punch_out_utc_datetime_save,
                                "HH:mm"
                              )
                            }}
                          </span>
                          <TimePickerSheet
                            v-if="
                              iSEdited && Number(item.is_punch_out_required)
                            "
                            isEnd
                            isRequire
                            :show48="23"
                            showDay
                            hideDetail
                            @modify="
                              item.is_change_modified_punch_out_utc_datetime = true
                            "
                            :showLabel="false"
                            :min="item.modified_punch_in_utc_datetime"
                            :value="item.modified_punch_out_utc_datetime"
                            :defaultTime="item.modified_punch_out_utc_datetime"
                            placeholder="__:__"
                            @change="
                              (time) => {
                                item.modified_punch_out_utc_datetime = time;
                              }
                            "
                        /></v-sheet>
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <!--  -->
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet width="100%">
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_officialPunchTime"
                          )
                        }}
                      </div>
                      <div
                        class="
                          d-flex
                          flex-row
                          justify-space-between
                          flex-grow-1
                          mt-2
                        "
                        style="width: 100%"
                      >
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                          :title="
                            $getDateTime(
                              item.official_punch_in_utc_datetime_save,
                              'YYYY/MM/DD HH:mm'
                            )
                          "
                        >
                          {{
                            Math.floor(
                              Math.abs(
                                item[
                                  "official_punch_in_utc_datetime_save_minutes"
                                ]
                              ) / 1440
                            ) == 0
                              ? ""
                              : item[
                                  "official_punch_in_utc_datetime_save_minutes"
                                ]
                              ? item[
                                  "official_punch_in_utc_datetime_save_minutes"
                                ] > 0
                                ? "(+" +
                                  Math.floor(
                                    Math.abs(
                                      item[
                                        "official_punch_in_utc_datetime_save_minutes"
                                      ]
                                    ) / 1440
                                  ) +
                                  ")"
                                : "(-" +
                                  Math.floor(
                                    Math.abs(
                                      item[
                                        "official_punch_in_utc_datetime_save_minutes"
                                      ]
                                    ) / 1440
                                  ) +
                                  ")"
                              : ""
                          }}
                          {{
                            $getDateTime(
                              item.official_punch_in_utc_datetime_save,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                        <div style="width: 20px" class="text-center">-</div>
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                          :title="
                            $getDateTime(
                              item.official_punch_out_utc_datetime_save,
                              'YYYY/MM/DD HH:mm'
                            )
                          "
                        >
                          {{
                            Math.floor(
                              Math.abs(
                                item[
                                  "official_punch_out_utc_datetime_save_minutes"
                                ]
                              ) / 1440
                            ) == 0
                              ? ""
                              : item[
                                  "official_punch_out_utc_datetime_save_minutes"
                                ]
                              ? item[
                                  "official_punch_out_utc_datetime_save_minutes"
                                ] > 0
                                ? "(+" +
                                  Math.floor(
                                    Math.abs(
                                      item[
                                        "official_punch_out_utc_datetime_save_minutes"
                                      ]
                                    ) / 1440
                                  ) +
                                  ")"
                                : "(-" +
                                  Math.floor(
                                    Math.abs(
                                      item[
                                        "official_punch_out_utc_datetime_save_minutes"
                                      ]
                                    ) / 1440
                                  ) +
                                  ")"
                              : ""
                          }}
                          {{
                            $getDateTime(
                              item.official_punch_out_utc_datetime_save,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                      </div>
                      <!-- 2021-03-19 不显示 brain lsj -->
                      <div class="mt-2" v-if="false">
                        <v-chip small>
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_totalLabel"
                            )
                          }}({{ $timeMachine(item.total_minutes, false) }})
                        </v-chip>
                        <v-chip
                          small
                          color="red"
                          v-if="Number(item.late_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_lateLabel"
                            )
                          }}({{ $timeMachine(item.late_minutes, false) }})
                        </v-chip>
                        <!-- <v-chip
                          small
                          color="red"
                          v-if="Number(item.late_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_lateLabel"
                            )
                          }}({{ $timeMachine(item.late_minutes, false) }})
                        </v-chip> -->
                        <v-chip
                          small
                          color="red"
                          v-if="Number(item.early_leave_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_earlyLeaveLabel"
                            )
                          }}({{
                            $timeMachine(item.early_leave_minutes, false)
                          }})
                        </v-chip>
                        <v-chip
                          small
                          color="primary"
                          v-if="
                            Number(item.ot_minutes_before) +
                            Number(item.ot_minutes_after)
                          "
                        >
                          {{
                            $t("label_essweb_attendanceModifiApp_form_otLabel")
                          }}({{
                            $timeMachine(
                              Number(item.ot_minutes_before) +
                                Number(item.ot_minutes_after),
                              false
                            )
                          }})
                        </v-chip>
                      </div>
                    </v-sheet>
                  </v-sheet>
                </v-sheet>
              </v-sheet>
            </v-sheet>
            <v-sheet
              width="30"
              height="60"
              :elevation="2"
              class="
                mt-6
                align-center
                text-center
                align-items-center
                text--primary
                rounded-r-lg
                d-flex
                flex-column
                title
              "
              color="white"
              style="cursor: pointer"
              @click="slideOpen = !slideOpen"
            >
              <span class="material-icons-round ma-auto">{{
                slideOpen ? "arrow_left" : "arrow_right"
              }}</span>
            </v-sheet>
          </v-container>
          <!-- right -->
          <v-sheet
            :width="showTab ? 350 : 100"
            :height="!showTab ? 40 : undefined"
            elevation="1"
            class="pa-1 rounded-xl panel_right"
          >
            <v-btn
              style="
                position: absolute;
                right: 5px;
                z-index: 10;
                margin-top: 0px;
              "
              icon
              @click="showTab = !showTab"
            >
              <span class="material-icons-round">{{
                showTab ? "keyboard_arrow_up" : "keyboard_arrow_down"
              }}</span>
            </v-btn>
            <span
              v-show="!showTab"
              class="material-icons-round text--secondary"
              style="
                position: absolute;
                right: 60px;
                z-index: 10;
                margin-top: 5px;
              "
              >bar_chart</span
            >
            <Taber
              :curTab="curTab"
              @change="(tab) => (curTab = tab)"
              :items="taber"
              v-if="showTab"
              special
              :height="40"
              backgroundColor="white"
              :centered="false"
              :showTab="showTab"
              :grow="false"
            >
              <template v-slot:content-1>
                <v-form
                  class="max-width"
                  :class="iSEdited && canEditTotal ? 'px-0' : 'px-3'"
                  ref="recordform"
                  lazy-validation
                >
                  <v-row class="max-width mx-0 py-3" align="center">
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div>
                        <span v-if="!canEditTotal">
                          {{
                            $timeMachine(
                              Data["official_working_minutes"] || 0,
                              false
                            )
                          }}</span
                        >

                        <TimePickerSheet
                          v-else
                          isRequire
                          format
                          :height="25"
                          hideDetail
                          :showLabel="false"
                          :value="Data.modified_working_minutes"
                          :defaultTime="Data.modified_working_minutes"
                          placeholder="00:00"
                          :label="
                            $t(
                              'label_essweb_attendanceModifiApp_form_totalWorkingLabel'
                            )
                          "
                          @change="
                            (time) => {
                              Data.modified_working_minutes = time;
                            }
                          "
                        />
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_break_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_break_minutes"
                        :defaultTime="Data.modified_break_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_break_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_meal_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_meal_mintues"
                        :defaultTime="Data.modified_meal_mintues"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalMealMinutes'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_meal_mintues = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalOTLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_total_ot_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_ot_minutes"
                        :defaultTime="Data.modified_ot_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalOTLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_ot_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalLateLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_total_late_minutes"] || 0,
                            false
                          )
                        }}
                      </span>

                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_late_minutes"
                        :defaultTime="Data.modified_late_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalLateLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_late_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_total_early_leave_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_early_leave_minutes"
                        :defaultTime="Data.modified_early_leave_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_early_leave_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_total_leave_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_leave_minutes"
                        :defaultTime="Data.modified_leave_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalLeaveLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_leave_minutes = time;
                          }
                        "
                      />
                    </v-col>

                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_absense_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_absense_minutes"
                        :defaultTime="Data.modified_absense_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalAbsenseLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_absense_minutes = time;
                          }
                        "
                      />
                    </v-col>

                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_before_work_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_before_work_minutes"
                        :defaultTime="Data.modified_before_work_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_before_work_minutes = time;
                          }
                        "
                      />
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 5 : 7"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <div class="text-subtitle-2 text--primary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                          )
                        }}
                      </div>
                    </v-col>
                    <v-col
                      :md="canEditTotal ? 7 : 5"
                      class="text-center"
                      :class="!canEditTotal ? 'pa-0' : 'pt-1 '"
                    >
                      <span v-if="!canEditTotal">
                        {{
                          $timeMachine(
                            Data["official_after_work_minutes"] || 0,
                            false
                          )
                        }}
                      </span>
                      <TimePickerSheet
                        v-else
                        isRequire
                        format
                        :height="25"
                        hideDetail
                        :showLabel="false"
                        :value="Data.modified_after_work_minutes"
                        :defaultTime="Data.modified_after_work_minutes"
                        placeholder="00:00"
                        :label="
                          $t(
                            'label_essweb_attendanceModifiApp_form_totalAfterWorkLabel'
                          )
                        "
                        @change="
                          (time) => {
                            Data.modified_after_work_minutes = time;
                          }
                        "
                      />
                    </v-col> </v-row
                ></v-form>
              </template>
              <template v-slot:content-2>
                <div class="px-3">
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_working_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_break_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_meal_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_totalOTLabel")
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{ $timeMachine(Data["actual_ot_minutes"] || 0, false) }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLateLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_late_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_early_leave_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_leave_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(Data["actual_absense_minutes"] || 0, false)
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_before_work_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["actual_after_work_minutes"] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </Taber>
          </v-sheet>
          <!-- v-if="showMap && markers.length > 0" 没有打卡记录不显示地图 brain 2021-06-04-->
          <GmapMap
            :center="center"
            v-if="showMap && markers.length > 0"
            :zoom="18"
            ref="curmap"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              keyboardShortcuts: false,
              gestureHandling: 'greedy',
              fullscreenControl: false,
              disableDefaultUi: false,
              controlSize: 22,
            }"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :option="{ animation: 'drop', shape: 'circle' }"
              :position="m.position"
              :icon="makericon"
              :clickable="true"
              :draggable="false"
              @click="toggleInfoWindow(m, index)"
            />
            <!-- size: new google.maps.Size(20, 20),
                  origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 20)-->
            <gmap-info-window
              class="mb-4"
              :options="{
                pixelOffset: {
                  width: 0,
                  height: -70,
                },
              }"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <v-sheet width="200" class="pl-n3">
                <!-- shift -->
                <v-sheet
                  class="d-flex flex-row justify-start align-center py-3"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon
                      size="24"
                      :fill="Data['official_shift_color_code']"
                      iconClass="LabeledColour"
                    />
                  </div>
                  <div
                    style="max-width: 80%"
                    class="pl-1 d-inline-block text-truncate text-body-1"
                  >
                    {{ $getCommonLangValue(Data["official_shift_name"]) }}
                  </div>
                </v-sheet>
                <!-- event -->
                <v-sheet
                  class="d-flex flex-row justify-start my-2"
                  v-for="(item, index) in curRecord"
                  :key="`record---${index}`"
                >
                  <v-sheet
                    width="1"
                    height="auto"
                    color="black   mr-2"
                  ></v-sheet>
                  <v-sheet>
                    <div class="text-subtitle-2 text--primary py-1">
                      {{ $getCommonLangValue(item.event_type_name) }}({{
                        item["punch_type"] == 1
                          ? $t("label_essweb_attendanceRecord_list_inLabel")
                          : item["punch_type"] == 2
                          ? $t("label_essweb_attendanceRecord_list_outLabbel")
                          : ""
                      }})
                    </div>
                    <v-sheet class="d-flex align-center flex-row justify-start">
                      <span class="material-icons-round text--secondary">
                        schedule
                      </span>
                      <div
                        class="text-subtitle-2 grey lighten-3 ml-2 px-8 rounded"
                      >
                        {{
                          $getDateTime(
                            item["punch_type"] == 1
                              ? item["actual_punch_in_utc_datetime"]
                              : item["punch_type"] == 2
                              ? item["actual_punch_out_utc_datetime"]
                              : "",
                            "HH:mm"
                          )
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                </v-sheet>
              </v-sheet>
            </gmap-info-window>
            <!-- icon="//www.google.com/images/branding/product/i
            co/maps15_bnuw3a_32dp.ico" -->
          </GmapMap>
        </v-card-text>
      </v-card>
      <v-card class="pa-0 elevation-0" v-if="iSEdited">
        <v-card-text class="pa-3">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <AutoComplete
                  label="label_essweb_myAttendance_form_modifiReasonLabel"
                  v-model="attendance_modification_reason_uuid"
                  :items="modifiReason"
                  item-value="value_field"
                  item-text="view_fields"
                >
                </AutoComplete>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_myAttendance_form_messageLabel')"
                  v-model="remarks"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <CardActions submitBtn @submit="toSubmit" @cancel="toBack(isChanged)" />
      </v-card>
    </template>
    <template v-slot:tools-main>
      <!-- select Sender -->
      <selectSender
        :show="showSender"
        :staff_uuid="curStaff"
        @onSave="toSave"
        @need="
          (sender) => {
            curSender = sender;
            needSender = false;
          }
        "
        @noSender="
          (no) => {
            noSender = no;
          }
        "
        @close="showSender = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import selectSender from "@/Page/Ess/Attendance/MyAttendance/components/selectSender";
import dayjs from "dayjs";

import makericon from "@/assets/AttendancePoint.png";
import mapbg from "@/assets/mapbg.svg";
import { gmapApi } from "vue2-google-maps";
export default {
  name: "viewPunchVerifyFailedApplication",
  components: { selectSender },
  computed: {
    ...mapGetters(["companyLang", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    leftWidth() {
      return this.slideOpen ? 375 : 0;
    },
  },
  watch: {
    iSEdited(val) {
      this.canEditTotal = val;
    },
  },
  data() {
    return {
      Data: null,
      users: [],
      canEditTotal: false, //是否允许编辑总时间，buglist 1490
      showSender: false,
      noSender: false,
      modifiReason: [],
      is_skip_approval: 1,
      mapbg: mapbg,
      needSender: true,
      curSender: [],
      isChanged: false,
      attendance_modification_reason_uuid: "",
      remarks: "",
      iSEdited: false,
      curTab: "tab-1",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      curRecord: [],
      showMap: true,
      curStaff: null,
      showTab: true,
      google: null,
      taber: [
        "label_essweb_attendanceModifiApp_form_tab_officialLabel",
        "label_essweb_attendanceModifiApp_form_tab_actualLabel",
      ],
      slideOpen: true,
      makericon: makericon,
      center: { lat: 1.312878, lng: 103.837811 },
      markers: [],
      user: null,
      page_params: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getBtnPermissionList();
    this.getModifiReason();
    this.getDetail();
    const that = this;
    if (this.$vuetify.breakpoint.name == "xs") {
      this.showTab = false;
    }
    if (
      this.curAppInfo["user"]["latitude"] != undefined &&
      this.curAppInfo["user"]["longitude"] != undefined
    ) {
      this.center = {
        lat: Number(this.curAppInfo["user"]["latitude"]),
        lng: Number(this.curAppInfo["user"]["longitude"]),
      };
    }
    this.$gmapApiPromiseLazy().then(() => {
      that.google = new gmapApi();
    });
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.curRecord = marker.record;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    toSubmit: function () {
      if (Number(this.is_skip_approval) || this.noSender) {
        this.toSave(null);
      } else {
        if (this.needSender) this.showSender = true;
        else this.toSave(this.curSender);
      }
    },
    setCenter: function (position) {
      const that = this;
      this.$refs.curmap.$mapPromise.then((map) => {
        map.setCenter(position);
        that.center = position;
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
        } else {
          this.$router.back();
        }
      }
    },
    toSave: function (sender) {
      const that = this;
      this.showSender = false;
      let arr = [];
      that.Data["ess_att_attendance_detail"].map((item) => {
        let modifi_outTime = "";
        let modifi_inTime = "";
        // let start_Date = item["official_punch_in_utc_datetime_save"];
        // if (!start_Date) {
        let start_Date = item["utc_att_date"];
        // }
        if (Number(item["is_punch_in_required"])) {
          if (item["modified_punch_in_utc_datetime"] >= 0) {
            if (item["modified_punch_in_utc_datetime"] >= 1440) {
              let day = parseInt(item["modified_punch_in_utc_datetime"] / 1440);
              let min = item["modified_punch_in_utc_datetime"] % 1440;
              modifi_inTime = new Date(
                dayjs(
                  dayjs(start_Date).add(day, "day").format("YYYY-MM-DD")
                ).add(min, "minute")
              ).getTime();
            } else {
              modifi_inTime = new Date(
                dayjs(start_Date).format("YYYY-MM-DD") +
                  " " +
                  that.$timeMachine(item["modified_punch_in_utc_datetime"])
              ).getTime();
            }
          } else {
            //减
            if (
              Math.abs(Number(item["modified_punch_in_utc_datetime"])) >= 1440
            ) {
              let day = parseInt(item["modified_punch_in_utc_datetime"] / 1440);
              let min = item["modified_punch_in_utc_datetime"] % 1440;
              modifi_inTime = new Date(
                dayjs(
                  dayjs(start_Date)
                    .subtract(Math.abs(day), "day")
                    .format("YYYY-MM-DD")
                ).add(Math.abs(min), "minute")
              ).getTime();
            } else {
              modifi_inTime = new Date(
                dayjs(dayjs(start_Date).format("YYYY-MM-DD")).add(
                  Math.abs(Number(item["modified_punch_in_utc_datetime"])),
                  "minute"
                )
              ).getTime();
            }
          }
        } else {
          modifi_inTime = start_Date;
        }
        if (Number(item["is_punch_out_required"])) {
          if (item["modified_punch_out_utc_datetime"] >= 0) {
            if (item["modified_punch_out_utc_datetime"] >= 1440) {
              let day = parseInt(
                item["modified_punch_out_utc_datetime"] / 1440
              );
              let min = item["modified_punch_out_utc_datetime"] % 1440;
              modifi_outTime = new Date(
                dayjs(
                  dayjs(start_Date).add(day, "day").format("YYYY-MM-DD")
                ).add(min, "minute")
              ).getTime();
            } else {
              modifi_outTime = new Date(
                dayjs(start_Date).format("YYYY-MM-DD") +
                  " " +
                  that.$timeMachine(item["modified_punch_out_utc_datetime"])
              ).getTime();
            }
          } else {
            //减
            if (
              Math.abs(Number(item["modified_punch_out_utc_datetime"])) >= 1440
            ) {
              let day = parseInt(
                item["modified_punch_out_utc_datetime"] / 1440
              );
              let min = item["modified_punch_out_utc_datetime"] % 1440;
              modifi_outTime = new Date(
                dayjs(
                  dayjs(start_Date)
                    .subtract(Math.abs(day), "day")
                    .format("YYYY-MM-DD")
                ).add(Math.abs(min), "minute")
              ).getTime();
            } else {
              modifi_outTime = new Date(
                dayjs(dayjs(start_Date).format("YYYY-MM-DD")).add(
                  Math.abs(Number(item["modified_punch_out_utc_datetime"])),
                  "minute"
                )
              ).getTime();
            }
          }
        } else {
          modifi_outTime = item["modified_punch_out_utc_datetime_save"];
        }
        // 是否修改过
        if (!item["is_change_modified_punch_in_utc_datetime"]) {
          modifi_inTime = item["modified_punch_in_utc_datetime_save"];
        }
        if (!item["is_change_modified_punch_out_utc_datetime"]) {
          modifi_outTime = item["modified_punch_out_utc_datetime_save"];
        }
        arr.push({
          event_type_uuid: item["event_type_uuid"],
          event_type_code: item["event_type_code"],
          event_property_group_uuid: item["event_property_group_uuid"],
          event_uuid: item["event_uuid"],
          attendance_detail_uuid: item["uuid"],
          actual_punch_in_uuid: item["actual_punch_in_uuid"],
          actual_punch_out_uuid: item["actual_punch_out_uuid"],
          actual_punch_in_utc_datetime: item["actual_punch_in_utc_datetime"],
          actual_punch_in_time_zone: item["actual_punch_in_time_zone"],
          actual_punch_out_utc_datetime: item["actual_punch_out_utc_datetime"],
          actual_punch_out_time_zone: item["actual_punch_out_time_zone"],
          modified_punch_in_utc_datetime: modifi_inTime,
          modified_punch_in_time_zone: item["official_punch_in_time_zone"],
          modified_punch_out_utc_datetime: modifi_outTime,
          modified_punch_out_time_zone: item["official_punch_out_time_zone"],
        });
      });
      this.$confirmWarn(
        this.$t("message_essweb_form_textField_notIncorrect_title"),
        this.$t(
          "label_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordWarningLabel"
        )
      ).then((res) => {
        if (res) {
          let data = {
            modified_working_minutes: that.Data.modified_working_minutes,
            modified_meal_mintues: that.Data.modified_meal_mintues,
            modified_break_minutes: that.Data.modified_break_minutes,
            modified_ot_minutes: that.Data.modified_ot_minutes,
            modified_late_minutes: that.Data.modified_late_minutes,
            modified_early_leave_minutes:
              that.Data.modified_early_leave_minutes,
            modified_leave_minutes: that.Data.modified_leave_minutes,
            modified_absense_minutes: that.Data.modified_absense_minutes,
            modified_before_work_minutes:
              that.Data.modified_before_work_minutes,
            modified_after_work_minutes: that.Data.modified_after_work_minutes,
            applicant_staff_uuid: that.Data.staff_uuid,
            submit_staff_uuid: that.curAppInfo
              ? that.curAppInfo["user"]["user_id"]
              : "",
            attendance_modification_reason_uuid:
              this.attendance_modification_reason_uuid,
            remarks: this.remarks,
            attendance_master_uuid: that.Data.uuid,
            official_shift_uuid: that.Data.official_shift_uuid,
            ess_att_attendance_modification_application_detail: arr,
          };
          if (sender) {
            data["sender_uuid"] = sender.join(",");
          }
          that
            .$Request({
              method: "POST",
              table: "ess_att_attendance_application",
              url: "/attendance-master/update/",
              data: data,
            })
            .then((res) => {
              that.toBack();
              that.$showMessage({
                text: that.$t(
                  "message_essweb_RosterFormRecord_form_slide_modifyAttenndanceRecordSuccessLabel"
                ),
                type: "success",
              });
            });
        }
      });
    },
    getDays: function (start, end) {
      start = new Date(start);
      end = new Date(end);
      if (!start || !end) return "";
      if (isNaN(start) || isNaN(end)) return "";
      let day = parseInt((Number(start) - Number(end)) / (24 * 60 * 60 * 1000));
      return day > 0 ? "(+" + day + ")" : "";
    },
    getModifiReason: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_attendance_modification_reason_select",
      }).then((res) => {
        that.modifiReason = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        if (res.data["ess_punch_records"])
          if (res.data["ess_punch_records"].length > 0) {
            res.data["ess_punch_records"].map((item) => {
              that.center = {
                lat: Number(item.latitude),
                lng: Number(item.longitude),
              };
              let arr = [];
              res.data["ess_att_attendance_detail"].map((ite) => {
                if (ite["actual_punch_in_uuid"] == item["uuid"]) {
                  let obj = JSON.parse(JSON.stringify(ite));
                  obj["punch_type"] = 1;
                  arr.push(obj);
                }
                if (ite["actual_punch_out_uuid"] == item["uuid"]) {
                  let obj = JSON.parse(JSON.stringify(ite));
                  obj["punch_type"] = 2;
                  arr.push(obj);
                }
              });
              that.markers.push({
                open: false,
                uuid: item.uuid,
                punch_type: item.punch_type,
                punch_utc_datetime: item.punch_utc_datetime,
                object: item,
                record: arr,
                position: {
                  lat: Number(item.latitude),
                  lng: Number(item.longitude),
                },
              });
            });
          }
        that.is_skip_approval = 1; //跳过选择审批人,lsj//管理端开启不需要审批Number(res.data.is_skip_approval)
        if (res.data["ess_att_attendance_detail"]) {
          res.data["ess_att_attendance_detail"].map((item) => {
            // 记录修改
            item["is_change_official_punch_in_utc_datetime"] = false;
            item["is_change_official_punch_out_utc_datetime"] = false;
            item["is_change_modified_punch_in_utc_datetime"] = false;
            item["is_change_modified_punch_out_utc_datetime"] = false;
            //
            item["official_punch_in_utc_datetime_save"] =
              item["official_punch_in_utc_datetime"];
            item["official_punch_out_utc_datetime_save"] =
              item["official_punch_out_utc_datetime"];
            item["modified_punch_in_utc_datetime_save"] =
              item["modified_punch_in_utc_datetime"];
            item["modified_punch_out_utc_datetime_save"] =
              item["modified_punch_out_utc_datetime"];
            // official
            if (item["official_punch_in_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["official_punch_in_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["official_punch_in_utc_datetime"] =
                dayjs(
                  Number(item["official_punch_in_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["official_punch_in_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["official_punch_in_utc_datetime"] = -(
                  item["official_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["official_punch_in_utc_datetime"] =
                  item["official_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["official_punch_in_utc_datetime"] = 0;
            }
            item["official_punch_in_utc_datetime_save_minutes"] =
              item["official_punch_in_utc_datetime"];
            if (item["official_punch_out_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["official_punch_out_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["official_punch_out_utc_datetime"] =
                dayjs(
                  Number(item["official_punch_out_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["official_punch_out_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["official_punch_out_utc_datetime"] = -(
                  item["official_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["official_punch_out_utc_datetime"] =
                  item["official_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["official_punch_out_utc_datetime"] = 0;
            }
            item["official_punch_out_utc_datetime_save_minutes"] =
              item["official_punch_out_utc_datetime"];
            //modifi
            if (item["modified_punch_in_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["modified_punch_in_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["modified_punch_in_utc_datetime"] =
                dayjs(
                  Number(item["modified_punch_in_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["modified_punch_in_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_in_utc_datetime"] = -(
                  item["modified_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_in_utc_datetime"] =
                  item["modified_punch_in_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["modified_punch_in_utc_datetime"] = 0;
            }

            if (item["modified_punch_out_utc_datetime"]) {
              let day =
                new Date(
                  dayjs(item["modified_punch_out_utc_datetime"]).format(
                    "YYYY-MM-DD"
                  )
                ).getTime() -
                new Date(
                  dayjs(item["utc_att_date"]).format("YYYY-MM-DD")
                ).getTime();

              item["modified_punch_out_utc_datetime"] =
                dayjs(
                  Number(item["modified_punch_out_utc_datetime_save"])
                ).hour() *
                  60 +
                dayjs(
                  Number(item["modified_punch_out_utc_datetime_save"])
                ).minute();
              if (day < 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_out_utc_datetime"] = -(
                  item["modified_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000)
                );
              }
              if (day > 0 && Math.abs(day) >= 86400000) {
                item["modified_punch_out_utc_datetime"] =
                  item["modified_punch_out_utc_datetime"] +
                  1440 * parseInt(Math.abs(day) / 86400000);
              }
            } else {
              item["modified_punch_out_utc_datetime"] = 0;
            }
          });
        }
        that.attendance_modification_reason_uuid =
          res.data["attendance_modification_reason_uuid"];
        that.remarks = res.data["remarks"];
        that.curStaff = res.data["staff_uuid"];
        that.Data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.panel_left {
  position: absolute;
  z-index: 2;
}
.panel_btn {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  margin-top: -40px;
  margin-left: -30px;
}
.panel_right {
  position: absolute;
  right: 20px;
  margin-top: 20px;
  z-index: 2;
}
.mrc_map {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.col-md-7 {
  -webkit-box-flex: 0 !important;
  -ms-flex: 0 0 58.3333333333% !important;
  flex: 0 0 58.3333333333% !important;
  max-width: 58.3333333333% !important;
}
</style>
